// The iFood visual catalog contains raw API objects required by the editor. Keep
// them in React state, but do not let a large import fill the browser's storage.
export const MAX_CATALOG_WORKSPACE_CHARS = 250_000;

export const persistCatalogWorkspace = (storage, key, workspace) => {
  const drafts = { ...workspace, visualCatalog: undefined };
  let fullValue;
  let draftsValue;
  try {
    draftsValue = JSON.stringify(drafts);
  } catch {
    return 'unavailable';
  }

  // Stop before serializing a very large raw catalog on every editor update.
  if (draftsValue.length <= MAX_CATALOG_WORKSPACE_CHARS) {
    try {
      let estimatedChars = 0;
      fullValue = JSON.stringify(workspace, (field, value) => {
        estimatedChars += field.length + (typeof value === 'string' ? value.length + 2 : 4);
        if (estimatedChars > MAX_CATALOG_WORKSPACE_CHARS) throw new RangeError('catalog-workspace-limit');
        return value;
      });
    } catch {
      fullValue = null;
    }
  }

  if (fullValue && fullValue.length <= MAX_CATALOG_WORKSPACE_CHARS) {
    try {
      storage.setItem(key, fullValue);
      return 'complete';
    } catch {
      // The existing value may itself occupy most of the storage quota.
    }
  }

  // Never leave an older visual catalog available for a later reload.
  try {
    storage.removeItem(key);
  } catch {
    return 'unavailable';
  }
  if (draftsValue.length > MAX_CATALOG_WORKSPACE_CHARS) return 'unavailable';
  try {
    storage.setItem(key, draftsValue);
    return 'drafts-only';
  } catch {
    return 'unavailable';
  }
};

export const persistSelectedCatalogMerchant = (storage, key, merchantId) => {
  try {
    if (merchantId) storage.setItem(key, JSON.stringify(merchantId));
    else storage.removeItem(key);
    return true;
  } catch {
    // A failed switch must not restore the previous merchant on reload.
    try {
      storage.removeItem(key);
      if (merchantId) storage.setItem(key, JSON.stringify(merchantId));
      return true;
    } catch {
      return false;
    }
  }
};
